import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-fiscal-document-totals',
  standalone: true,
  imports: [CommonModule, MatDividerModule],
  templateUrl: './fiscal-document-totals.component.html',
  styleUrls: ['./fiscal-document-totals.component.scss'],
  host: {
    '[class.fd-totals--view]': 'isViewMode'
  }
})
export class FiscalDocumentTotalsComponent {
  @Input() subtotal = 0;
  @Input() taxBreakdown: { taxName: string; taxAmount: number }[] = [];
  @Input() taxTotal = 0;
  @Input() total = 0;
  @Input() taxModeNone = false;
  @Input() isViewMode = false;
}
